"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputField = void 0;
var preact_1 = require("preact");
var a11y_wrapper_1 = require("../../hoc/a11y-wrapper");
var styles = require("./InputField.scss");
var InputField = /** @class */ (function (_super) {
    __extends(InputField, _super);
    function InputField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            active: false
        };
        _this._inputRef = null;
        _this.setFocus = function (options) {
            var _a;
            (_a = _this._inputRef) === null || _a === void 0 ? void 0 : _a.focus(options);
        };
        _this._handleOnChange = function (e) {
            _this.props.onChange(e.target.value);
        };
        _this._onClear = function () {
            var _a;
            (_a = _this._inputRef) === null || _a === void 0 ? void 0 : _a.focus();
            _this.props.onChange('');
        };
        _this._onFocus = function () {
            _this.setState({
                active: true
            });
        };
        _this._onBlur = function () {
            _this.setState({
                active: false
            });
        };
        _this._goToNextSearchResult = function () {
            var searchResults = _this.props.searchResults;
            var _a = searchResults, activeSearchIndex = _a.activeSearchIndex, totalSearchResults = _a.totalSearchResults, onSearchIndexChange = _a.onSearchIndexChange;
            if (totalSearchResults === 0) {
                return;
            }
            var index = 0;
            if (activeSearchIndex !== totalSearchResults) {
                index = activeSearchIndex + 1;
            }
            else {
                index = 1;
            }
            onSearchIndexChange(index);
        };
        _this._goToPrevSearchResult = function () {
            var searchResults = _this.props.searchResults;
            var _a = searchResults, activeSearchIndex = _a.activeSearchIndex, totalSearchResults = _a.totalSearchResults, onSearchIndexChange = _a.onSearchIndexChange;
            var index = 0;
            if (activeSearchIndex !== 1) {
                index = activeSearchIndex - 1;
            }
            else {
                index = totalSearchResults;
            }
            onSearchIndexChange(index);
        };
        _this._renderSearchResults = function () {
            return ((0, preact_1.h)(preact_1.Fragment, null,
                (0, preact_1.h)("div", { className: styles.searchResults, "aria-live": "polite", "aria-label": _this.props.searchResults.searchResultsLabel }, "".concat(_this.props.searchResults.totalSearchResults > 0
                    ? "".concat(_this.props.searchResults.activeSearchIndex, "/").concat(_this.props.searchResults.totalSearchResults)
                    : '0/0')),
                (0, preact_1.h)("div", { className: styles.prevNextWrapper },
                    _this.props.value && ((0, preact_1.h)(a11y_wrapper_1.A11yWrapper, { onClick: _this._goToPrevSearchResult },
                        (0, preact_1.h)("button", { tabIndex: 0, className: "".concat(styles.prevNextButton, " ").concat(_this.props.searchResults.totalSearchResults === 0 ? styles.disabled : ''), "aria-label": _this.props.searchResults.prevMatchLabel },
                            (0, preact_1.h)("svg", { width: "8", height: "5", viewBox: "0 0 8 5", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                (0, preact_1.h)("path", { d: "M0.292893 4.70711C0.653377 5.06759 1.22061 5.09532 1.6129 4.7903L1.70711 4.70711L4 2.415L6.29289 4.70711C6.65338 5.06759 7.22061 5.09532 7.6129 4.7903L7.70711 4.70711C8.06759 4.34662 8.09532 3.77939 7.7903 3.3871L7.70711 3.29289L4.70711 0.292893C4.34662 -0.0675907 3.77939 -0.0953203 3.3871 0.209705L3.29289 0.292893L0.292893 3.29289C-0.0976311 3.68342 -0.0976311 4.31658 0.292893 4.70711Z", fill: "white", "fill-opacity": "0.7" }))))),
                    _this.props.value && ((0, preact_1.h)(a11y_wrapper_1.A11yWrapper, { onClick: _this._goToNextSearchResult },
                        (0, preact_1.h)("button", { tabIndex: 0, className: "".concat(styles.prevNextButton, " ").concat(_this.props.searchResults.totalSearchResults === 0 ? styles.disabled : ''), "aria-label": _this.props.searchResults.nextMatchLabel },
                            (0, preact_1.h)("svg", { width: "8", height: "5", viewBox: "0 0 8 5", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                (0, preact_1.h)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L4 2.58579L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893C8.09763 0.683417 8.09763 1.31658 7.70711 1.70711L4.70711 4.70711C4.31658 5.09763 3.68342 5.09763 3.29289 4.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z", fill: "white", "fill-opacity": "0.7" }))))))));
        };
        _this._renderClearSearch = function () {
            return ((0, preact_1.h)(a11y_wrapper_1.A11yWrapper, { onClick: _this._onClear },
                (0, preact_1.h)("button", { className: styles.clearIcon, tabIndex: 0, "aria-label": _this.props.clearSearchLabel },
                    (0, preact_1.h)("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        (0, preact_1.h)("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM3.38951 2.3502L3.46013 2.41264L5.99548 4.9504L8.53067 2.41264L8.60129 2.3502C8.89537 2.12125 9.32081 2.1418 9.59133 2.41199C9.8844 2.70471 9.88469 3.17958 9.59197 3.47265L7.05523 6.01165L9.59197 8.55189C9.88469 8.84496 9.8844 9.31983 9.59133 9.61255C9.32081 9.88275 8.89537 9.90329 8.60129 9.67434L8.53067 9.61191L5.99548 7.0729L3.46013 9.61191L3.38951 9.67434C3.09543 9.90329 2.66999 9.88275 2.39947 9.61255C2.1064 9.31983 2.10611 8.84496 2.39883 8.55189L4.93498 6.01165L2.39883 3.47265C2.10611 3.17958 2.1064 2.70471 2.39947 2.41199C2.66999 2.1418 3.09543 2.12125 3.38951 2.3502Z", fill: "white", "fill-opacity": "0.7" })))));
        };
        _this.state = {
            active: false
        };
        return _this;
    }
    InputField.prototype.render = function () {
        var _this = this;
        var inputProps = {
            className: styles.inputElement,
            value: this.props.value,
            onInput: this._handleOnChange,
            onFocus: this._onFocus,
            onBlur: this._onBlur,
            tabIndex: 0,
            ref: function (node) {
                _this._inputRef = node;
            }
        };
        if (this.props.placeholder) {
            inputProps['aria-label'] = this.props.placeholder;
            inputProps['placeholder'] = this.props.placeholder;
        }
        return ((0, preact_1.h)("div", { className: [styles.inputFieldWrapper, this.props.value || this.state.active ? styles.active : ''].join(' ') },
            (0, preact_1.h)("input", __assign({}, inputProps)),
            this.props.value && this.props.clearSearchLabel && this._renderClearSearch(),
            this.props.value && this.props.searchResults && this._renderSearchResults()));
    };
    return InputField;
}(preact_1.Component));
exports.InputField = InputField;
//# sourceMappingURL=index.js.map